
import {Component, Prop, Vue} from 'vue-property-decorator';
import stores from '@/stores';
import {SweetModal} from 'sweet-modal-vue';
import GlobalFunctions from '@/GlobalFunctions';
import CombinedUser from '@/stores/CombinedUser';
import {showToaster} from '@/components/DashboardComposer/helpers';
import {translate} from '@/helpers/functions';

@Component({
  components: {
    SweetModal,
  },
})
export default class CreateCombinedUser extends Vue {

  @Prop({default: false})
  emitCreated!: boolean;

  @Prop()
  newuserIndex?: any;

  user: any = {
    firstName: '',
    lastName: '',
    active: true,
    username: '',
    email: '',
    gender: '',
    password: '',
  };

  globalFunctions = new GlobalFunctions();

  mounted() {
    const form = document.getElementById('create-form-combined-user')! as HTMLFormElement;
    // Loop over them and prevent submission
    form.addEventListener('submit', (event: any) => {
      event.preventDefault();
      if (form.checkValidity()) {
        event.stopPropagation();
        this.onSubmit();
      }
      if (!form.checkValidity()) {
        event.stopPropagation();
      }
      form.classList.add('was-validated');
    }, false);
  }

  onSubmit(): Promise<void | {}> {
    return stores.CombinedUsers.createItem(this.user)
      .then((response: any) => {
        if (!response.success) {
          // Loop through the errors object and log each message
          for (const field in response.errors) {
            if (response.errors.hasOwnProperty(field)) {
              const messages = response.errors[field];
              messages.forEach((message: any) => {
                showToaster('danger', '', message);
              });
            }
          }
        } else {
          showToaster('success', translate('successfully-created'), '');
          this.cancel();
          if (this.emitCreated) {
            this.$emit('created', response.data);
            return;
          }
          this.$router.push({
            name: 'combinedUser.show',
            params: {id: response.data.id},
          });
        }
      })
      .catch((e: any) => {
        console.log(e);
      });
  }

  cancel() {
    // @ts-ignore
    this.$children[0].close();
  }
}
